// src/components/layout/AuthLayout.jsx
import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";

const AuthLayout = ({ children }) => {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
};

export default AuthLayout;
